import ApiService from '../services/api';

/**
 * Stats Snapshot API (GET /api/stats)
 * Unified endpoint for all statistics data.
 * 
 * Query params:
 * - from (required): YYYY-MM-DD
 * - to (required): YYYY-MM-DD
 * - scopeType: 'global' | 'user' | 'customer' | 'carrier' (default: 'global')
 * - scopeId: ObjectId (required if scopeType !== 'global')
 * - statuses: CSV string (e.g., 'delivered,pickedUp')
 * - paymentType: 'receivable' | 'payable'
 * - grain: 'day' | 'week' | 'month' | 'year' (auto-selected if not provided)
 * 
 * Response: { success: true, data: { totals, breakdowns, points[] }, meta: {...} }
 */
class StatsApiService extends ApiService {
  constructor() {
    super('/api/stats');
  }

  /**
   * Get statistics data
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  async getStats(params = {}) {
    return await this.get('', params);
  }

  async getTopUsers(params = {}) {
    return await this.get('/top-users', params);
  }

  async getUsersByRole(params = {}) {
    return await this.get('/users/by-role', params);
  }

  async getCarriersSummary(params = {}) {
    return await this.get('/carriers-summary', params);
  }

  async getCustomersSummary(params = {}) {
    return await this.get('/customers-summary', params);
  }

  /**
   * @deprecated Use getStats() directly
   */
  async getDashboard(params = {}) {
    return await this.getStats(params);
  }

  /**
   * @deprecated Use getStats() directly
   */
  async getLoadsStats(params = {}) {
    return await this.getStats(params);
  }

  /**
   * @deprecated Use getStats() directly
   */
  async getCarriersStats(params = {}) {
    return await this.getStats(params);
  }

  /**
   * @deprecated Use getStats() directly
   */
  async getCustomersStats(params = {}) {
    return await this.getStats(params);
  }

  /**
   * @deprecated Use getStats() with paymentType param instead
   */
  async getPaymentsStats(params = {}) {
    return await this.getStats(params);
  }
}

export default new StatsApiService();
